import script from "./ShippingAddressTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingAddressTile.vue?vue&type=script&setup=true&lang=js"

import "./ShippingAddressTile.vue?vue&type=style&index=0&id=f427b64c&lang=scss"

const __exports__ = script;

export default __exports__